<template>
  <div class="manutencao-container">
    <div class="logo-container">
      <img class="logo-rte-manutencao" src="../../assets/images/RTE-Logo.svg" alt="logo-rte" />
    </div>
    <h1>Em manutenção</h1>
    <img class="gear-manutencao" src="../../assets/images/gears.gif" alt="engrenagens" />
    <h2>A ferramenta está sendo otimizada para uma melhor experiência.</h2>
  </div>
</template>

<script>
import rteLogo from "@/assets/images/RTE-Logo.svg";

export default {
  name: "PaginaManutencao",
  components: {
    rteLogo
  }
};
</script>

<style lang="scss" scoped>
.manutencao-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background: var(--branco);
  padding-bottom: 50px;
  h1,
  h2 {
    font-family: "Roboto Condensed";
    margin-bottom: 0;
    text-align: center;
  }
}
.gear-manutencao {
  height: 250px;
}
.logo-rte-manutencao {
  height: 250px;
  margin-right: 40px;
  // margin-bottom: 30px;
}
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  margin-bottom: 20px;
}
</style>
